import React, { useEffect, useRef, useState } from 'react'
import styles from "./sticker.module.css"
import MediaUnavailable from '../MediaUnavailable'

const PLAY_DURATION_MS = 6000

const Sticker = ({ url, animated = false }) => {
    const imgRef = useRef(null)
    const timeoutRef = useRef(null)
    const [playing, setPlaying] = useState(true)
    const [staticSrc, setStaticSrc] = useState("")
    const [failed, setFailed] = useState(false)

    useEffect(() => {
        setFailed(false)
        if (!animated) return

        startPlayback()
        return () => clearTimeout(timeoutRef.current)
    }, [url, animated])

    const captureStaticFrame = () => {
        const img = imgRef.current
        if (!img) return false
        if (staticSrc) return true

        try {
            const canvas = document.createElement("canvas")
            canvas.width = img.naturalWidth || 150
            canvas.height = img.naturalHeight || 150

            const context = canvas.getContext("2d")
            context.drawImage(img, 0, 0, canvas.width, canvas.height)
            setStaticSrc(canvas.toDataURL("image/webp"))
            return true
        } catch (err) {
            setStaticSrc("")
            return false
        }
    }

    const startPlayback = () => {
        if (!url) return

        clearTimeout(timeoutRef.current)
        const img = imgRef.current
        if (img) {
            img.src = ''
            img.src = url
        }
        setPlaying(true)
        timeoutRef.current = setTimeout(() => {
            if (captureStaticFrame()) {
                setPlaying(false)
            }
        }, PLAY_DURATION_MS)
    }

    const handleLoad = () => {
        if (animated) {
            setTimeout(captureStaticFrame, 120)
        }
    }

    if (failed) {
        return <MediaUnavailable type="sticker" onRetry={() => setFailed(false)} />
    }

    return (
        <button
            type="button"
            className={styles.container}
            title={animated ? "Reproduzir figurinha" : "Figurinha"}
            onMouseEnter={animated ? startPlayback : undefined}
            onClick={animated ? startPlayback : undefined}
        >
            {animated && staticSrc &&
                <img
                    src={staticSrc}
                    alt="Figurinha"
                    className={`${styles.sticker} ${styles.background}`}
                />
            }
            <img
                ref={imgRef}
                src={`${url}`}
                alt="Figurinha"
                className={`${styles.sticker} ${animated && !playing ? styles.paused : ""}`}
                onLoad={handleLoad}
                onError={() => setFailed(true)}
            />
        </button>
    )
}

export default Sticker
